import * as React from 'react';
import { isMobilePhoneNumberValid, prettifySSN, stripCharacter, validateSSN } from '@kvika/string-utils';
import LoginForm from './LoginForm';
import { StyledContentWrapper, StyledLoginSubtitle, StyledLoginTitle, StyledTitle } from '../styles/LoginStyles';
import Tabs from './Tabs';
import LoginMethods from './LoginMethods';
import { LoginMethodsEnum, TabsEnum } from './Constants';
var MAX_PHONE_NUMBER_LENGTH = 7;
var MAX_SSN_LENGTH = 10;
var Login = function (_a) {
    var _b = _a.legalBinderPhoneNumber, legalBinderPhoneNumber = _b === void 0 ? '' : _b, translations = _a.translations, onValidationChange = _a.onValidationChange, onChange = _a.onChange, onKeyPress = _a.onKeyPress, className = _a.className, testId = _a.testId, _c = _a.width, width = _c === void 0 ? '100%' : _c, _d = _a.defaultSelectedTab, defaultSelectedTab = _d === void 0 ? TabsEnum.Einstaklingur : _d, _e = _a.defaultSelectedLoginMethod, defaultSelectedLoginMethod = _e === void 0 ? LoginMethodsEnum.ELECTRONIC_ID : _e, _f = _a.defaulnSsn, defaulnSsn = _f === void 0 ? '' : _f;
    var _g = React.useState(legalBinderPhoneNumber), phoneNumber = _g[0], setPhoneNumber = _g[1];
    var _h = React.useState(false), textFieldDirty = _h[0], setTextFieldDirty = _h[1];
    var _j = React.useState(defaultSelectedTab), selectedTab = _j[0], setSelectedTab = _j[1];
    var _k = React.useState(defaultSelectedLoginMethod), selectedLoginMethod = _k[0], setSelectedLoginMethod = _k[1];
    var _l = React.useState(true), isValid = _l[0], setIsValid = _l[1];
    var label = translations.label, loginMethods = translations.loginMethods;
    var _m = React.useState(defaulnSsn), ssn = _m[0], setSsn = _m[1];
    React.useEffect(function () {
        setPhoneNumber('');
        setSsn('');
        setTextFieldDirty(false);
    }, [selectedLoginMethod]);
    React.useEffect(function () {
        setPhoneNumber(legalBinderPhoneNumber);
    }, [legalBinderPhoneNumber]);
    React.useEffect(function () {
        if (onChange) {
            onChange(phoneNumber, ssn, selectedLoginMethod, selectedTab);
        }
    }, [selectedTab, onChange, phoneNumber, selectedLoginMethod, ssn]);
    var handleChange = function (e) {
        var newNumber = stripCharacter(e.target.value).substring(0, MAX_PHONE_NUMBER_LENGTH);
        setPhoneNumber(newNumber);
        var valid = isMobilePhoneNumberValid(newNumber);
        if (onValidationChange) {
            onValidationChange(isMobilePhoneNumberValid(newNumber));
        }
        if (onChange) {
            onChange(newNumber, ssn, selectedLoginMethod, selectedTab);
        }
        setIsValid(valid);
    };
    var getLoginForm = function () {
        return (React.createElement(LoginForm, { label: label, value: selectedLoginMethod === LoginMethodsEnum.ELECTRONIC_ID ? phoneNumber : prettifySSN(ssn), onChange: selectedLoginMethod === LoginMethodsEnum.ELECTRONIC_ID
                ? handleChange
                : function (event) {
                    var newSsn = event.target.value.replace('-', '').substring(0, MAX_SSN_LENGTH);
                    setSsn(newSsn);
                    var isSsnValid = validateSSN(newSsn);
                    if (onValidationChange) {
                        onValidationChange(isSsnValid);
                    }
                    setIsValid(isSsnValid);
                }, onBlur: function () {
                if (selectedLoginMethod === LoginMethodsEnum.ELECTRONIC_ID) {
                    setIsValid(phoneNumber.length > 0 ? isMobilePhoneNumberValid(phoneNumber) : true);
                }
                else {
                    setIsValid(validateSSN(ssn));
                }
                if (phoneNumber.length > 0 || ssn.length > 0) {
                    setTextFieldDirty(true);
                }
            }, error: !isValid && textFieldDirty, helperText: selectedLoginMethod === LoginMethodsEnum.ELECTRONIC_ID
                ? translations.invalidPhoneNumberMsg
                : translations.invalidSsnMsg, onKeyPress: onKeyPress, testId: testId }));
    };
    return (React.createElement("div", { className: className, "data-testid": testId },
        React.createElement(StyledTitle, null, translations.title),
        React.createElement(StyledContentWrapper, { width: width },
            React.createElement(StyledLoginTitle, null, translations.loginTitle),
            React.createElement(StyledLoginSubtitle, null, translations.loginSubtitle),
            React.createElement(Tabs, { setSelectedTab: setSelectedTab, selectedTab: selectedTab, testId: testId, tabs: translations.tabs }),
            loginMethods && (React.createElement(LoginMethods, { setSelectedLoginMethod: setSelectedLoginMethod, selectedLoginMethod: selectedLoginMethod, loginMethods: translations.loginMethods, testId: testId })),
            getLoginForm())));
};
export default Login;
//# sourceMappingURL=Login.js.map